"use client";

import { useEffect, useState } from "react";
import { Menu, Search, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuList, NavigationMenuTrigger, NavigationMenuContent, NavigationMenuLink } from "@/components/ui/navigation-menu";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { FormProvider } from "@/integrations/forms/FormProvider";
import { Link } from "@/components/common/Link";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-2">
        <div className="h-9 w-24 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-24 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList>
        {menuItems.map(item => {
        if (item.children && item.children.length > 0) {
          return <NavigationMenuItem key={item.id}>
                <NavigationMenuTrigger className="text-foreground font-default text-xs tracking-[0.15em] uppercase hover:text-secondary transition-colors" style={{
              color: '#2A2825',
              fontWeight: 300
            }}>
                  {item.label}
                </NavigationMenuTrigger>
                <NavigationMenuContent>
                  <div className="w-56 p-2 bg-background border border-border shadow-lg">
                    {item.children.map(child => <NavigationMenuLink key={child.id} asChild>
                        <Link to={child.href || "#"} className="block rounded-md px-3 py-2 text-xs font-default tracking-[0.15em] uppercase text-foreground hover:bg-accent hover:text-secondary transition-colors" style={{
                    color: '#2A2825',
                    fontWeight: 300
                  }}>
                          {child.label}
                        </Link>
                      </NavigationMenuLink>)}
                  </div>
                </NavigationMenuContent>
              </NavigationMenuItem>;
        }
        return <NavigationMenuItem key={item.id}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="text-foreground font-default text-xs tracking-[0.15em] uppercase hover:text-secondary transition-colors relative group" style={{
              color: '#2A2825',
              fontWeight: 300
            }}>
                  {item.label}
                  <span className="absolute -bottom-1 left-1/2 w-0 h-px bg-secondary transition-all duration-300 group-hover:w-full group-hover:left-0" />
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>;
      })}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-2">
        <div className="h-8 w-full bg-muted animate-pulse rounded-md" />
        <div className="h-8 w-full bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <div className="flex flex-col gap-4">
      {menuItems.map(item => {
      if (item.children && item.children.length > 0) {
        return <div key={item.id}>
              <div className="font-default text-xs tracking-[0.15em] uppercase text-foreground mb-2" style={{
            color: '#2A2825',
            fontWeight: 300
          }}>{item.label}</div>
              <div className="ml-4 flex flex-col gap-2">
                {item.children.map(child => <Link key={child.id} to={child.href || "#"} className="text-foreground font-default text-xs tracking-[0.15em] uppercase hover:text-secondary transition-colors" style={{
              color: '#2A2825',
              fontWeight: 300
            }}>
                    {child.label}
                  </Link>)}
              </div>
            </div>;
      }
      return <Link key={item.id} to={item.href || "#"} className="text-foreground font-default text-xs tracking-[0.15em] uppercase hover:text-secondary transition-colors" style={{
        color: '#2A2825',
        fontWeight: 300
      }}>
            {item.label}
          </Link>;
    })}
    </div>;
}
export default function UneVieEnSuDe() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <>
      <aside className="w-full bg-[#B6593F] text-white py-2 px-4 transition-colors">
        <div className="container mx-auto flex items-center justify-center text-center">
          <Link to="/GuidePage" className="group inline-flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-xs font-default uppercase tracking-[0.12em] text-white hover:text-white/90 transition-opacity">
            <span className="font-normal opacity-95">CODE OCTOBER15 : -15% sur le guide « S'installer en Suède » jusqu'au 31 octobre 2026</span>
            <span className="inline-flex items-center gap-1 font-semibold underline underline-offset-4 decoration-white/70 group-hover:decoration-white">
              Découvrir le guide
              <ArrowRight className="size-3.5 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
            </span>
          </Link>
        </div>
      </aside>

      <section data-section-id="265103" id="une-vie-en-suède" className={`sticky top-0 z-40 w-full transition-all duration-500 ${isScrolled ? "bg-background/80 backdrop-blur-md border-b border-border shadow-sm" : "bg-background border-b border-border"}`}>
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex-shrink-0 flex flex-col hover:opacity-90 transition-opacity">
            <div className="flex items-center gap-2">
              <svg className="w-[18px] h-[18px] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#B6593F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M12 2L7 9h3l-4 7h5v5h2v-5h5l-4-7h3L12 2z" />
              </svg>
              <span className="font-serif text-xl sm:text-2xl font-bold tracking-tight text-[#2A2825]">
                Une Vie en <span className="italic text-[#B6593F]">Suède</span>
              </span>
            </div>
            <span className="hidden sm:block text-[9px] tracking-[0.25em] uppercase text-[#2A2825]/70 font-sans mt-0.5 font-medium">
              Chroniques &amp; guides depuis Stockholm
            </span>
          </Link>

          <div className="hidden md:flex items-center justify-center gap-6 flex-1 mx-8">
            <MenuProvider menu_id="16">
              <HeaderMenuConsumer />
            </MenuProvider>
            <FormProvider>
              <form method="get" action="/" role="search" className="relative flex items-center">
                <input type="search" name="s" placeholder="Rechercher…" aria-label="Rechercher" className="h-9 w-36 focus:w-48 transition-all duration-300 rounded-md border border-border bg-background px-3 py-1 pr-9 text-xs placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring" />
                <Button type="submit" variant="ghost" size="icon" className="absolute right-0 h-9 w-9 text-muted-foreground hover:text-foreground" aria-label="Rechercher">
                  <Search className="w-4 h-4" />
                </Button>
              </form>
            </FormProvider>
          </div>

          <div className="md:hidden flex items-center gap-3">
            <Sheet>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="text-foreground">
                  <Menu className="w-6 h-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-64 bg-background border-l border-border">
                <div className="mt-8">
                  <div className="mb-8 flex flex-col items-center text-center">
                    <Link to="/" className="inline-flex flex-col items-center hover:opacity-90 transition-opacity">
                      <div className="flex items-center gap-2">
                        <svg className="w-[18px] h-[18px] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="#B6593F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                          <path d="M12 2L7 9h3l-4 7h5v5h2v-5h5l-4-7h3L12 2z" />
                        </svg>
                        <span className="font-serif text-xl font-bold tracking-tight text-[#2A2825]">
                          Une Vie en <span className="italic text-[#B6593F]">Suède</span>
                        </span>
                      </div>
                      <span className="text-[9px] tracking-[0.2em] uppercase text-[#2A2825]/70 font-sans mt-1 font-medium">
                        Chroniques &amp; guides depuis Stockholm
                      </span>
                    </Link>
                  </div>
                  <FormProvider>
                    <form method="get" action="/" role="search" className="relative flex items-center mb-6">
                      <input type="search" name="s" placeholder="Rechercher…" aria-label="Rechercher" className="h-9 w-full rounded-md border border-border bg-background px-3 py-1 pr-9 text-xs placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring" />
                      <Button type="submit" variant="ghost" size="icon" className="absolute right-0 h-9 w-9 text-muted-foreground hover:text-foreground" aria-label="Rechercher">
                        <Search className="w-4 h-4" />
                      </Button>
                    </form>
                  </FormProvider>
                  <MenuProvider menu_id="16">
                    <MobileMenuConsumer />
                  </MenuProvider>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </section>
    </>;
}